import type { TrackConfig } from './features/track/type'

export const trackList: TrackConfig[] = [
  {
    event: 'datastore_upload',
    eventName: '上传知识库',
    trigger: ['click'],
  },
  {
    event: 'datastore_doc_cut',
    eventName: '分段剪切',
    trigger: ['click'],
  },
  {
    event: 'datastore_doc_merge',
    eventName: '分段合并',
    trigger: ['click'],
  },
  {
    event: 'datastore_doc_open',
    eventName: '打开文件',
    trigger: ['click'],
  },
  {
    event: 'datastore_doc_save',
    eventName: '知识库文件保存',
    trigger: ['click'],
  },
  {
    event: 'flow_code_node_run',
    eventName: 'Flow_Code节点运行',
    trigger: ['click'],
  },
  {
    event: 'flow_code_doc_open',
    eventName: 'Flow_Code节点打开文档',
    trigger: ['click'],
  },
  {
    event: 'flow_code_example_copy',
    eventName: 'Flow_Code节点实例代码复制',
    trigger: ['click'],
  },
]
